import { ChangeDetectionStrategy, Component, HostListener, effect, inject, input, output, signal } from '@angular/core';
import { DigitalAssistantService } from '../../../digital-assistant.service';
import { MatFormField, MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';

import { MatIcon } from '@angular/material/icon';
import { L10nTranslatePipe } from 'angular-l10n';


@Component({
  selector: 'miq-chat-input',
  templateUrl: './chat-input.component.html',
  styleUrl: './chat-input.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatFormField, MatInput, FormsModule, MatIcon, L10nTranslatePipe],
})
export class ChatInputComponent {
  readonly sendMessage = output<string>();
  readonly isResponseInProgress = input(false);
  readonly messageInput = input('', { alias: 'message' });
  readonly messageChange = output<string>();

  readonly messageValue = signal('');

  private typingTimeout: any;
  private readonly chatBotService = inject(DigitalAssistantService);

  constructor() {
    effect(() => {
      this.messageValue.set(this.messageInput());
    });
  }

  onMessageChange(value: string) {
    this.messageValue.set(value);

    if (this.typingTimeout) {
      clearTimeout(this.typingTimeout);
    }

    this.typingTimeout = setTimeout(() => {
      this.messageChange.emit(value);
    }, 500);
  }

  send() {
    if (this.messageValue().trim()) {
      this.sendMessage.emit(this.messageValue());
      this.messageValue.set('');
      this.chatBotService.isPredefinedPromptSelected.set(false);
      this.chatBotService.selectedPredefinedPrompt.set('');
    }
  }

  showPromptsPanel() {
    this.chatBotService.isPromptsPanelOpen.update(prev => !prev);
    this.chatBotService.trackUserAction('Pre-defined Prompts panel opened (View All Prompts)');
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
    }
  }
}
